import React from 'react';
export const WideArrowForward = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0001 19C9.76643 19.0004 9.53999 18.919 9.36008 18.77H9.36008C8.93491 18.4175 8.87599 17.787 9.22848 17.3619C9.22901 17.3612 9.22954 17.3606 9.23008 17.36L13.7101 12L9.39008 6.62995L9.39008 6.62995C9.04192 6.20123 9.10723 5.57144 9.53595 5.22328C9.53733 5.22217 9.5387 5.22106 9.54008 5.21995V5.21995C9.95471 4.85513 10.5866 4.89551 10.9514 5.31014C10.9684 5.32945 10.9846 5.3494 11.0001 5.36995L15.8301 11.37C16.1334 11.739 16.1334 12.271 15.8301 12.64L10.8301 18.64H10.8301C10.6266 18.8854 10.3183 19.0191 10.0001 19L10.0001 19Z",
  fill: "currentColor"
}));